import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useIsMobileDevice } from '../../../../../hooks';
import * as styles from './Footer.css';

interface IFooterProps {
  onClick(): void;
}

export const Footer: React.FC<IFooterProps> = ({ onClick }) => {
  const isMobile = useIsMobileDevice();

  return (
    <div className={styles['button-container']}>
      <Button onClick={onClick} fullWidth={isMobile} size={isMobile ? 'M' : 'XS'}>
        Понятно
      </Button>
    </div>
  );
};
